<template>
  <USelectMenu
    :model-value="modelValue"
    :items="items"
    :by="by"
    :placeholder="placeholder"
    :filter-fields="filterFields"
    :search-input="{ placeholder: $t('general.search') }"
    multiple
    class="w-full"
    :ui="{
      value: 'truncate',
      itemWrapper: 'min-w-0',
      itemLabel: 'truncate',
      content: contentClass,
      viewport: 'max-h-72',
    }"
    @update:model-value="(value: any) => $emit('update:modelValue', Array.isArray(value) ? value : [])"
  />
</template>

<script setup lang="ts">
interface Props {
  modelValue?: any[]
  items?: any[] | any[][]
  by: string
  placeholder: string
  contentClass?: string
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: () => [],
  items: () => [],
  contentClass: 'max-h-72 overflow-y-auto',
})

defineEmits<{
  (e: 'update:modelValue', value: any[]): void
}>()

const filterFields = computed(() => ['label', 'title', 'displayName', 'name'])
</script>
